import _ from 'lodash'
import { Feature } from 'ol'
import Collection from 'ol/Collection'
import { GeoJSON } from 'ol/format'
import { Geometry, GeometryCollection } from 'ol/geom'
import Vector from 'ol/layer/Vector'
import Map from 'ol/Map'
import VectorSource from 'ol/source/Vector'
import { Fill, Stroke, Text } from 'ol/style'
import React, { useEffect, useState } from 'react'
import { Checkbox } from 'semantic-ui-react'
import { StyledLayerType } from './slice'

type props = {
  map: Map,
  styledLayerSet: StyledLayerType
  className: string
}

export default function PlacenameSearchOverlay({ map, styledLayerSet, className }: props) {
  const [checked, setChecked] = useState(true)
  const [vectorLayer, setVectorLayer] = useState<Vector<VectorSource>>()

  //Create polygon
  useEffect(
    () => {
      let layer: Vector<VectorSource>
      const layerFeaturesCollection = new Collection<Feature>()
      if (!_.isEmpty(styledLayerSet) && styledLayerSet) {
        const styledLayerSetData = styledLayerSet.data
        let styledLayerFeatures: Feature<Geometry>[] = []
        styledLayerSetData.forEach(
          (styleData) => {
            if (styleData.altGeometry && styleData.altGeometry.length > 0 && styleData.altGeometry[0]) {
              //Data projection will be automatically detected by GeoJSON, which is EPSG:4283
              let geometries: Geometry[] = []
              styleData.altGeometry.forEach(
                (altGeometry) => {
                  let geometry = (new GeoJSON()).readGeometry(altGeometry).transform('EPSG:4326', 'EPSG:3857')
                  geometries.push(geometry)
                },
              )
              const hasLocation = (!!(styleData.latitude && styleData.longitude))
              const layerFeature = new Feature({
                fillColor: styledLayerSet.fillColor,
                geometry: new GeometryCollection(geometries),
                name: styleData.searchTerm,
                id: styleData.placeId,
                hasLocation: hasLocation,
              })
              const polygonStyle = styledLayerSet.style.clone()
              const label = new Text({
                font: '12px Calibri,sans-serif',
                overflow: true,
                fill: new Fill({
                  color: '#007aff',
                }),
                stroke: new Stroke({
                  color: '#fff',
                  width: 3,
                }),
                offsetY: -40,
                text: layerFeature.get('name'),
              })
              polygonStyle.setText(label)
              if (!hasLocation) {
                layerFeature.setStyle(polygonStyle)
              }
              styledLayerFeatures.push(layerFeature)
            }
          })
        if (styledLayerFeatures.length > 0) {
          layerFeaturesCollection.extend(styledLayerFeatures)
        }
        layer = new Vector({
          source: new VectorSource({
              features: layerFeaturesCollection,
            },
          ),
          style: styledLayerSet.style,
          className: className,
          properties: {
            name: className,
          },
        })
        layer.setVisible(checked)
        setVectorLayer(layer)
        map.addLayer(layer)
      }
      return () => {
        layerFeaturesCollection.clear()
        if (layer) map.removeLayer(layer)
      }

    }, [styledLayerSet],
  )
  return (
    <div>
      <Checkbox
        label={styledLayerSet?.type}
        className={'checkbox-' + className}
        checked={checked}
        onClick={(e, props) => setChecked(props.checked !== undefined ? props.checked : false)}
        onChange={(e, props) => vectorLayer?.setVisible(props.checked !== undefined ? props.checked : false)}
      />
    </div>
  )
}